// Note: ipfs-http-client is deprecated but still works for this project
// For production, consider using Helia (https://github.com/ipfs/helia)
import { create as ipfsHttpClient } from 'ipfs-http-client';
import ipfsService from '../services/IPFSService';
// Buffer is provided via ProvidePlugin in webpack config

// Use environment variables for IPFS credentials
const projectId = process.env.REACT_APP_INFURA_IPFS_PROJECT_ID || '2DBM8M1VMImQ5vl4IQxYQzI8uKg';
const projectSecret = process.env.REACT_APP_INFURA_IPFS_PROJECT_SECRET || 'f34bbedac4f01e7e79a9c99d04ba08cf';
const auth = 'Basic ' + Buffer.from(projectId + ':' + projectSecret).toString('base64');

// Direct IPFS client (for uploads only - uses Infura)
const client = ipfsHttpClient({
  host: 'infura.io',
  port: 5001,
  protocol: 'https',
  apiPath: '/api/v0',
  headers: { authorization: auth }
});

// Function to upload JSON data to IPFS
export const uploadJsonToIPFS = async (jsonData) => {
  try {
    // Convert the JSON to a string
    const jsonString = JSON.stringify(jsonData);
    const blob = new Blob([jsonString], { type: 'application/json' });
    
    console.log('Starting JSON upload to IPFS...');
    
    // Upload the JSON to IPFS
    const added = await client.add(blob, {
      pin: true,
      wrapWithDirectory: false
    });
    
    console.log('IPFS upload result:', added);
    
    // Get the CID from the result
    const cid = added.cid.toString();
    console.log('IPFS CID:', cid);

    // Build the IPFS URL with the CID using multi-gateway service
    const ipfsUrl = ipfsService.getPrimaryGatewayUrl(cid);
    console.log('IPFS URL:', ipfsUrl);

    // Return the result
    return {
      path: cid,
      url: ipfsUrl,
      size: added.size,
      fileName: `${cid}.json`,
      ipfsGatewayUrl: ipfsUrl
    };
  } catch (error) {
    console.error('Error uploading JSON to IPFS:', error);
    throw error;
  }
};

// Function to get JSON from IPFS by its CID
// Now uses multi-gateway IPFSService for reliability
export const getJsonFromIPFS = async (cid) => {
  try {
    console.log('Getting JSON from IPFS with multi-gateway fallback:', cid);

    // Try to parse as JSON first using multi-gateway service
    try {
      const jsonData = await ipfsService.fetchJSON(cid);
      const url = ipfsService.getPrimaryGatewayUrl(cid);
      return { url, data: jsonData };
    } catch (parseError) {
      // If it's not JSON, get as text (it might be encrypted text)
      const textContent = await ipfsService.fetchText(cid);
      const url = ipfsService.getPrimaryGatewayUrl(cid);
      return { url, data: textContent };
    }
  } catch (error) {
    console.error('Error getting JSON from IPFS:', error);
    throw error;
  }
};

export default client;